var render = function () {
  var _this$form$total, _this$form$total2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', [_c('div', {
    staticClass: "d-flex justify-content-end gap-1"
  }, [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(186, 191, 199, 0.15)',
      expression: "'rgba(186, 191, 199, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "mb-75",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goToEdit
    }
  }, [_vm._v(" Edit ")]), _c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(186, 191, 199, 0.15)',
      expression: "'rgba(186, 191, 199, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "mb-75 ml-1",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.printInvoice
    }
  }, [_vm._v(" Print ")])], 1), _c('div', {
    staticClass: "settings-sidebar"
  }, [_c('h3', {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v("Invoice Settings")]), _c('hr'), _c('h4', [_vm._v("Company Information")]), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.company_name.enabled,
      expression: "settings.company_name.enabled"
    }],
    attrs: {
      "type": "checkbox",
      "id": "company_name"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.company_name.enabled) ? _vm._i(_vm.settings.company_name.enabled, null) > -1 : _vm.settings.company_name.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.settings.company_name.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings.company_name, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings.company_name, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings.company_name, "enabled", $$c);
        }
      }
    }
  }), _c('label', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "for": "company_name"
    }
  }, [_vm._v("Company Name")])]), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.company_email.enabled,
      expression: "settings.company_email.enabled"
    }],
    attrs: {
      "type": "checkbox",
      "id": "company_email"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.company_email.enabled) ? _vm._i(_vm.settings.company_email.enabled, null) > -1 : _vm.settings.company_email.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.settings.company_email.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings.company_email, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings.company_email, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings.company_email, "enabled", $$c);
        }
      }
    }
  }), _c('label', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "for": "company_email"
    }
  }, [_vm._v("Company Email")])]), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.company_phone.enabled,
      expression: "settings.company_phone.enabled"
    }],
    attrs: {
      "type": "checkbox",
      "id": "company_phone"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.company_phone.enabled) ? _vm._i(_vm.settings.company_phone.enabled, null) > -1 : _vm.settings.company_phone.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.settings.company_phone.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings.company_phone, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings.company_phone, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings.company_phone, "enabled", $$c);
        }
      }
    }
  }), _c('label', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "for": "company_phone"
    }
  }, [_vm._v("Company Phone")])]), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.company_address.enabled,
      expression: "settings.company_address.enabled"
    }],
    attrs: {
      "type": "checkbox",
      "id": "company_address"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.company_address.enabled) ? _vm._i(_vm.settings.company_address.enabled, null) > -1 : _vm.settings.company_address.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.settings.company_address.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings.company_address, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings.company_address, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings.company_address, "enabled", $$c);
        }
      }
    }
  }), _c('label', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "for": "company_address"
    }
  }, [_vm._v("Company Address")])]), _c('h4', [_vm._v("Customer Information")]), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.customer_name.enabled,
      expression: "settings.customer_name.enabled"
    }],
    attrs: {
      "type": "checkbox",
      "id": "customer_name"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.customer_name.enabled) ? _vm._i(_vm.settings.customer_name.enabled, null) > -1 : _vm.settings.customer_name.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.settings.customer_name.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings.customer_name, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings.customer_name, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings.customer_name, "enabled", $$c);
        }
      }
    }
  }), _c('label', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "for": "customer_name"
    }
  }, [_vm._v("Customer Name")])]), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.customer_email.enabled,
      expression: "settings.customer_email.enabled"
    }],
    attrs: {
      "type": "checkbox",
      "id": "customer_email"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.customer_email.enabled) ? _vm._i(_vm.settings.customer_email.enabled, null) > -1 : _vm.settings.customer_email.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.settings.customer_email.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings.customer_email, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings.customer_email, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings.customer_email, "enabled", $$c);
        }
      }
    }
  }), _c('label', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "for": "customer_email"
    }
  }, [_vm._v("Customer Email")])]), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.customer_phone.enabled,
      expression: "settings.customer_phone.enabled"
    }],
    attrs: {
      "type": "checkbox",
      "id": "customer_phone"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.customer_phone.enabled) ? _vm._i(_vm.settings.customer_phone.enabled, null) > -1 : _vm.settings.customer_phone.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.settings.customer_phone.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings.customer_phone, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings.customer_phone, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings.customer_phone, "enabled", $$c);
        }
      }
    }
  }), _c('label', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "for": "customer_phone"
    }
  }, [_vm._v("Customer Phone")])]), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.customer_address.enabled,
      expression: "settings.customer_address.enabled"
    }],
    attrs: {
      "type": "checkbox",
      "id": "customer_address"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.customer_address.enabled) ? _vm._i(_vm.settings.customer_address.enabled, null) > -1 : _vm.settings.customer_address.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.settings.customer_address.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings.customer_address, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings.customer_address, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings.customer_address, "enabled", $$c);
        }
      }
    }
  }), _c('label', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "for": "customer_address"
    }
  }, [_vm._v("Customer Address")])]), _c('h4', [_vm._v("Other Settings")]), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.invoice_logo_view.enabled,
      expression: "settings.invoice_logo_view.enabled"
    }],
    attrs: {
      "type": "checkbox",
      "id": "invoice_logo_view"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.invoice_logo_view.enabled) ? _vm._i(_vm.settings.invoice_logo_view.enabled, null) > -1 : _vm.settings.invoice_logo_view.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.settings.invoice_logo_view.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings.invoice_logo_view, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings.invoice_logo_view, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings.invoice_logo_view, "enabled", $$c);
        }
      }
    }
  }), _c('label', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "for": "invoice_logo_view"
    }
  }, [_vm._v("Invoice Logo")])]), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.notes.enabled,
      expression: "settings.notes.enabled"
    }],
    attrs: {
      "type": "checkbox",
      "id": "notes"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.notes.enabled) ? _vm._i(_vm.settings.notes.enabled, null) > -1 : _vm.settings.notes.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.settings.notes.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings.notes, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings.notes, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings.notes, "enabled", $$c);
        }
      }
    }
  }), _c('label', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "for": "notes"
    }
  }, [_vm._v("Notes")])]), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.discount.enabled,
      expression: "settings.discount.enabled"
    }],
    attrs: {
      "type": "checkbox",
      "id": "discount"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.discount.enabled) ? _vm._i(_vm.settings.discount.enabled, null) > -1 : _vm.settings.discount.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.settings.discount.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings.discount, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings.discount, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings.discount, "enabled", $$c);
        }
      }
    }
  }), _c('label', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "for": "discount"
    }
  }, [_vm._v("Discount")])]), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.tax.enabled,
      expression: "settings.tax.enabled"
    }],
    attrs: {
      "type": "checkbox",
      "id": "tax"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.tax.enabled) ? _vm._i(_vm.settings.tax.enabled, null) > -1 : _vm.settings.tax.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.settings.tax.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings.tax, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings.tax, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings.tax, "enabled", $$c);
        }
      }
    }
  }), _c('label', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "for": "tax"
    }
  }, [_vm._v("Tax")])]), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.vat.enabled,
      expression: "settings.vat.enabled"
    }],
    attrs: {
      "type": "checkbox",
      "id": "vat"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.vat.enabled) ? _vm._i(_vm.settings.vat.enabled, null) > -1 : _vm.settings.vat.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.settings.vat.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings.vat, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings.vat, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings.vat, "enabled", $$c);
        }
      }
    }
  }), _c('label', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "for": "vat"
    }
  }, [_vm._v("VAT")])]), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.settings.due_amount.enabled,
      expression: "settings.due_amount.enabled"
    }],
    attrs: {
      "type": "checkbox",
      "id": "due_amount"
    },
    domProps: {
      "checked": Array.isArray(_vm.settings.due_amount.enabled) ? _vm._i(_vm.settings.due_amount.enabled, null) > -1 : _vm.settings.due_amount.enabled
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.settings.due_amount.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.settings.due_amount, "enabled", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.settings.due_amount, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.settings.due_amount, "enabled", $$c);
        }
      }
    }
  }), _c('label', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "for": "due_amount"
    }
  }, [_vm._v("Due Amount")])])]), _c('div', {
    staticStyle: {
      "width": "210mn",
      "padding": "20mm",
      "margin": "auto",
      "background": "white",
      "box-shadow": "0 0 5px rgba(0, 0, 0, 0.1)",
      "box-sizing": "border-box",
      "position": "relative"
    },
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "margin": "0",
      "padding": "0",
      "position": "relative"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "max-width": "800px",
      "margin": "auto"
    }
  }, [_vm.settings.invoice_logo_view.enabled && this.form.invoice_logo ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [this.form.invoice_logo ? _c('img', {
    attrs: {
      "src": this.form.invoice_logo_view,
      "alt": "Company Logo",
      "height": "160"
    }
  }) : _vm._e()])]) : !_vm.settings.invoice_logo_view.enabled ? _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "160px"
    }
  })]) : _vm._e(), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "37%",
      "overflow-wrap": "break-word"
    }
  }, [_c('h1', {
    staticStyle: {
      "margin-top": "0px",
      "font-size": "28px"
    }
  }, [_vm._v("INVOICE")]), [_vm.settings.customer_name.enabled && this.form.customer_name ? _c('div', {
    staticClass: "flex items-center justify-between w-full"
  }, [_c('b', [_vm._v(_vm._s(this.form.customer_name))])]) : _vm._e(), _vm.settings.customer_email.enabled && this.form.customer_email ? _c('div', [_vm._v(" " + _vm._s(this.form.customer_email) + " ")]) : _vm._e(), _vm.settings.customer_phone.enabled && this.form.customer_phone ? _c('div', [_vm._v(" " + _vm._s(this.form.customer_phone) + " ")]) : _vm._e(), _vm.settings.customer_address.enabled && this.form.customer_address ? _c('div', [_vm._v(" " + _vm._s(this.form.customer_address) + " ")]) : _vm._e()]], 2), _c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "26%",
      "overflow-wrap": "break-word"
    }
  }, [_c('div', {
    staticClass: "margin-bottom:5px"
  }, [_c('strong', [_vm._v("Invoice No.")]), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v(_vm._s(this.form.invoice_number))])]), _c('br'), _c('div', {
    staticClass: "margin-bottom:5px"
  }, [_c('strong', [_vm._v("Invoice Date")]), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formatDate(this.form.issue_date)) + " ")])]), _c('br'), _c('div', {
    staticClass: "margin-bottom:5px"
  }, [_c('strong', [_vm._v("Due Date")]), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formatDate(this.form.due_date)) + " ")])])]), _c('div', {
    staticStyle: {
      "width": "37%",
      "overflow-wrap": "break-word"
    }
  }, [_vm.settings.company_name.enabled && this.form.company_name ? _c('strong', [_vm._v(_vm._s(this.form.company_name))]) : _vm._e(), _c('br'), _c('br'), _vm.settings.company_address.enabled && this.form.company_address ? _c('div', [_vm._v(" " + _vm._s(this.form.company_address) + " ")]) : _vm._e(), _vm.settings.company_phone.enabled && this.form.company_phone ? _c('div', [_vm._v(" Phone: " + _vm._s(this.form.company_phone) + " ")]) : _vm._e(), _vm.settings.company_email.enabled && this.form.company_email ? _c('div', [_vm._v(" Email: " + _vm._s(this.form.company_email) + " ")]) : _vm._e()])]), _c('table', {
    staticStyle: {
      "width": "100%",
      "border-collapse": "collapse",
      "margin-top": "20px"
    }
  }, [_c('thead', [_c('tr', {
    staticStyle: {
      "background-color": "#f5f5f5",
      "border": "1px solid black"
    }
  }, [_c('th', {
    staticStyle: {
      "padding": "10px",
      "text-align": "left",
      "border": "1px solid black",
      "font-size": "14px"
    }
  }, [_vm._v(" SL No. ")]), _c('th', {
    staticStyle: {
      "padding": "10px",
      "text-align": "left",
      "width": "40%",
      "border": "1px solid black",
      "font-size": "14px"
    }
  }, [_vm._v(" Description ")]), _c('th', {
    staticStyle: {
      "padding": "10px",
      "text-align": "left",
      "border": "1px solid black",
      "font-size": "14px"
    }
  }, [_vm._v(" Quantity ")]), _c('th', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "1px solid black",
      "font-size": "14px"
    }
  }, [_vm._v(" Unit Price (" + _vm._s(this.form.currency) + ") ")]), _c('th', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "1px solid black",
      "font-size": "14px"
    }
  }, [_vm._v(" Total (" + _vm._s(Math.ceil(this.form.total)) + ") [" + _vm._s(this.form.currency) + "] ")])])]), _c('tbody', [_vm._l(this.form.items, function (item, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "border": "1px solid black"
      }
    }, [_c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(index + 1))]), _c('td', {
      staticStyle: {
        "padding": "10px",
        "border": "1px solid black"
      }
    }, [_c('div', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(item.item_name))]), _c('p', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "text-truncate",
      staticStyle: {
        "max-width": "100%"
      },
      attrs: {
        "title": item === null || item === void 0 ? void 0 : item.item_description
      }
    }, [_vm._v(" " + _vm._s(item === null || item === void 0 ? void 0 : item.item_description) + " ")])]), _c('td', {
      staticStyle: {
        "padding": "10px",
        "border": "1px solid black"
      }
    }, [_vm._v(" " + _vm._s(item.quantity || 0) + " ")]), _c('td', {
      staticStyle: {
        "padding": "10px",
        "text-align": "right",
        "border": "1px solid black"
      }
    }, [_vm._v(" " + _vm._s(item.unit_price || 0) + " ")]), _c('td', {
      staticStyle: {
        "padding": "10px",
        "text-align": "right",
        "border": "1px solid black"
      }
    }, [_vm._v(" " + _vm._s(item.unit_price * item.quantity || 0) + " ")])]);
  }), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" Subtotal ")]), _c('td', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "1px solid black"
    }
  }, [_vm._v(" " + _vm._s(this.form.sub_total_amount) + " ")])]), _vm.settings.discount.enabled && this.form.discount ? _c('tr', [_c('td', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" Discount ")]), _c('td', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "1px solid black"
    }
  }, [_vm._v(" " + _vm._s(this.form.discount) + " ")])]) : _vm._e(), _vm.settings.tax.enabled && this.form.tax ? _c('tr', [_c('td', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" TAX ")]), _c('td', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "1px solid black"
    }
  }, [_vm._v(" " + _vm._s(this.form.tax) + " ")])]) : _vm._e(), _vm.settings.vat.enabled && this.form.vat ? _c('tr', [_c('td', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" VAT ")]), _c('td', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "1px solid black"
    }
  }, [_vm._v(" " + _vm._s(this.form.vat) + " ")])]) : _vm._e(), _vm.settings.due_amount.enabled && this.form.due_amount ? _c('tr', [_c('td', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" Due Amount ")]), _c('td', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "1px solid black"
    }
  }, [_vm._v(" " + _vm._s(this.form.due_amount) + " ")])]) : _vm._e(), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "border": "none"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" Grand Total ")]), _c('td', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right",
      "color": "red",
      "border": "1px solid black"
    }
  }, [_c('strong', [_vm._v(_vm._s(Math.ceil((_this$form$total = this.form.total) !== null && _this$form$total !== void 0 ? _this$form$total : 0)))])])])], 2)]), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h4', {
    staticStyle: {
      "font-size": "16px",
      "text-transform": "capitalize"
    }
  }, [_vm._v(" In Words: " + _vm._s(this.form.currency) + " " + _vm._s(_vm.numberToWords(Math.ceil((_this$form$total2 = this.form.total) !== null && _this$form$total2 !== void 0 ? _this$form$total2 : 0))) + " Only ")]), _vm.settings.notes.enabled && _vm.form.notes ? _c('h4', [_c('strong', [_vm._v("Note/Terms")])]) : _vm._e(), _vm.settings.notes.enabled && _vm.form.notes ? _c('div', [_vm._v(" " + _vm._s(_vm.form.notes) + " ")]) : _vm._e()]), _c('h2', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "40px",
      "margin-bottom": "40px"
    }
  }, [_vm._v(" Thank You For Your Business ")]), _c('br'), _c('div', {
    staticStyle: {
      "width": "100%",
      "margin": "0",
      "text-align": "center",
      "display": "block",
      "bottom": "0",
      "left": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto",
      "margin-bottom": "0.5rem",
      "display": "flex",
      "justify-content": "space-between",
      "flex-wrap": "wrap",
      "width": "80%"
    }
  }, [_vm.settings.company_phone.enabled && this.form.company_phone ? _c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#145bff"
    }
  }, [_vm._v("M: ")]), _vm._v(" " + _vm._s(this.form.company_phone) + " ")]) : _vm._e(), _vm.settings.company_email.enabled && this.form.company_email ? _c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#145bff"
    }
  }, [_vm._v("E: ")]), _vm._v(" " + _vm._s(this.form.company_email) + " ")]) : _vm._e(), _vm.settings.invoice_logo_view.enabled ? _c('span', [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "color": "#145bff"
    }
  }, [_vm._v("W: ")]), _c('a', {
    attrs: {
      "href": "https://viserx.com",
      "target": "_blank"
    }
  }, [_vm._v("www.viserx.com")])]) : _vm._e()]), _c('div', {
    staticStyle: {
      "margin-top": "8px",
      "margin-bottom": "3px"
    }
  }, [_vm._v(" " + _vm._s(this.form.company_name) + ", " + _vm._s(this.form.company_address) + " ")]), _c('div', {
    staticStyle: {
      "background-color": "#145bff",
      "height": "30px",
      "width": "100%"
    }
  })])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }